import React from 'react';
import {Card, Col, Container} from 'react-bootstrap';
import styles from './PublicBody.module.scss';
import {Outlet} from 'react-router';
import {PageFooter} from '../PageFooter/PageFooter';
import {getFullLogoLink} from '../../../appTheme';
import {Link} from 'react-router-dom';
import {RoutePaths} from '../../../router/RoutePaths';
import {Tooltip} from 'react-tooltip';

export function PublicBody(props: {}) {

  return (
    <Container fluid={true} className={styles['container']}>
      <Tooltip id='tooltip-id-anchor' place='top' closeOnEsc={true} delayShow={100} style={{zIndex: 2000}}/>
        <Col className={styles['page-body']}>
          <Link to={RoutePaths.publicPaths.landing} style={{display: 'flex', justifyContent: 'center'}} aria-label="Home of the Innocents">
            <img src={getFullLogoLink()} className={styles['logo']} alt="Home of the Innocents"/>
          </Link>
              <Container className={styles['content']}>
                <Outlet/>
              </Container>
          <PageFooter/>
        </Col>
        {/* Small footer link for staff login at bottom-left */}
        <Link
          to={RoutePaths.authPaths.login}
          className={styles['staffLogin']}
          aria-label="Staff login"
        >
          Staff login
        </Link>
    </Container>
  );
}
